export const FOOTER_HEIGHT = 70;
export const FOOTER_MARGIN = 32;
export const NAVBAR_HEIGHT = 60;
